<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-需求大厅-修改
    -->
    <el-dialog
    title="修改需求大厅"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">


          <!-- 新增：关联需求类型下拉列表 -->
      <el-form-item label="关联需求类型" prop="requirement_type_id">
        <el-select 
          v-model="form.requirement_type_id" 
          placeholder="请选择需求类型" 
          class="max-w460"
          clearable
        >
          <el-option 
            v-for="type in requirementTypes" 
            :key="type.requirement_type_id" 
            :label="type.name" 
            :value="type.requirement_type_id"
          ></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="需求信息" prop="name"><el-input v-model="form.name" placeholder="请输入需求大厅名称" class="max-w460"></el-input></el-form-item>
    

    

      <el-form-item label="图片：" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.image">
          <transition-group>
            <div v-for="(item, index) in form.image" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'image')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('image')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>





        <!-- 新增：需求大厅视频（与图片上传方式一致） -->
      <el-form-item label="视频：" prop="model.video">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.video">
          <transition-group>
            <div v-for="(item, index) in form.video" :key="item.file_path">
              <div class="item">
                <!-- 视频预览：用video标签，默认显示第一帧作为封面 -->
                <video 
                  :src="item.file_path" 
                  alt="video_path" 
                  controls 
                  preload="metadata" 
                  style="max-width:100%;max-height:100%;object-fit:contain;"
                ></video>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'video')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('video')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>

      <el-form-item label="需求描述">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  
 

     <!-- 新增：预算金额（匹配数据库 budget_amount） -->
      <el-form-item label="预算金额" prop="budget_amount">
        <el-input 
          v-model="form.budget_amount" 
          placeholder="请输入预算金额（如：10000.00）" 
          class="max-w460"
          type="number"
          step="0.01"
        ></el-input>
      </el-form-item>
           <!-- 新增：预算金额（匹配数据库 budget_amount） -->
      <el-form-item label="保证金" prop="budget_deposit">
        <el-input 
          v-model="form.budget_deposit" 
          placeholder="请输入保证金（如：10000.00）" 
          class="max-w460"
          type="number"
          step="0.01"
        ></el-input>
      </el-form-item>
      <!-- 新增：联系方式（匹配数据库 contact_information） -->
      <el-form-item label="联系方式" prop="contact_information">
        <el-input 
          v-model="form.contact_information" 
          placeholder="请输入联系方式（如：电话/微信/邮箱）" 
          class="max-w460"
        ></el-input>
      </el-form-item>   


            <!-- 新增：区域位置相关字段（适配数据库字段） -->
      <el-form-item label="详细地址" prop="address">
      <el-input v-model="form.address" placeholder="请输入详细地址" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="坐标">
        <el-row class="mb16">
          <el-col :span="24">
            <el-input v-model="form.coordinate" class="max-w460"></el-input>
          </el-col>
        </el-row>
        <el-row class="mb16">
          <el-col :span="24">
            <Getpoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
          </el-col>
        </el-row>

      </el-form-item>



      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
      <Upload v-if="isProductUpload" :config="uploadConfig" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传{{ uploadTypeText }}</Upload>
    </div>
</el-dialog>
  
</template>

<script>
import Requirement_hallApi from '@/api/requirement_hall.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import Getpoint from '@/components/map/Getpoint.vue'
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     draggable,
     Uediter,
     Getpoint
  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
          isImg: false,  
          /*富文本配置*/
          ueditor: {
          text: '',
          config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      requirementTypes: [],
      /* 新增：上传配置（区分图片/视频的格式和数量限制） */
      uploadConfig: { total: 3, accept: 'image/*' }, // 默认图片配置
      uploadTypeText: '图片',
      /*form表单数据*/
     form: {
  name: '',
  code: 'custom',
  image:[],
  sort:50,
  intro:"",
  video: [],
  longitude: '', 
  latitude: '', 
  address: '', // 确保有这个字段
  detailed_address: '', 
  completion_date: '',
  budget_amount: '', 
  budget_deposit:'',
  contact_information: '', 
  requirement_type_id: null,
  coordinate:"", // 坐标显示
},
      loading: false,
      /*验证规则*/
      rules: {
        requirement_type_id: [{ required: true, message: '请选择关联需求类型', trigger: 'change' }],
        
        name: [{ required: true, message: '请输入需求大厅名称', trigger: 'blur' }],
        completion_date: [{ required: true, message: '请选择完成时间', trigger: 'change' }], // 规则字段名同步修改为 completion_date

      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","requirement_hall_id"],
  methods: {

    /*获取经纬度*/
      getMapdataFunc(e) {
           this.form.longitude =  e.data[1].toFixed(6), 
        this.form.latitude = e.data[0].toFixed(6), 
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },

      /*选择的地址*/
      choseFunc(e){
        console.log("地址",e.location.lat)
         this.form.longitude =  +e.location.lng, 
        this.form.latitude = e.location.lat, 
        this.form.coordinate=e.location.lat+','+e.location.lng;
        this.form.address=e.address;

      },
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code;
      // 区分图片/视频的上传配置
      if (code === 'video') {
        this.uploadConfig = { total: 3, accept: 'video/*' }; // 视频：最多传3个，仅接受视频格式
        this.uploadTypeText = '视频'; // 弹窗标题显示“上传视频”
      } else {
        this.uploadConfig = { total: 9, accept: 'image/*' }; // 图片：最多传9个，仅接受图片格式
        this.uploadTypeText = '图片'; // 弹窗标题显示“上传图片”
      }
    },




     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
  getDetail() {
  let self = this;
  Requirement_hallApi.detail({requirement_hall_id: self.requirement_hall_id},true).then(res => {
      self.form = res.data;
      self.ueditor.text = self.form.intro;
      self.isImg = true
      self.loading = false;

      // 确保经纬度数据正确设置
      if (res.data.longitude && res.data.latitude) {
        self.form.longitude = res.data.longitude;
        self.form.latitude = res.data.latitude;
        // 设置坐标显示
        self.form.coordinate = res.data.latitude + ',' + res.data.longitude;
      }
      
      if(!self.form.bannar){
        self.form.bannar = [];
      }
      if(!self.form.image){
        self.form.image = [];
      }
    })
    .catch(error => {
      console.error('获取详情失败:', error);
    });
},
    onSubmit() {
      let self = this;
      let form = self.form;
      form.requirement_hall_id = self.requirement_hall_id;
      form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Requirement_hallApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else if(this.code == 'image'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else if(this.code == 'video'){ // 新增：视频处理逻辑
        if (e != null) {
        let videoExpt = ["mp4", "mov", "avi", "flv", "wmv"]; // 常见视频格式
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          videoExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("视频类型有误,请选择mp4/mov/avi/flv/wmv格式");
          return false;
        }

        let videos = this.form.video.concat(e);
        this.$set(this.form, "video", videos); // 将视频数据存入form.video
      }
    }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'image'){
        this.form.image.splice(index, 1);
      }else if(code == 'video'){ //删除视频
        this.form.video.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/requirement_hall/index/part/edit.vue